import { render } from "./AboutButton.vue?vue&type=template&id=02360aa0"
import script from "./AboutButton.vue?vue&type=script&lang=js"
export * from "./AboutButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__